import {ChangeDetectionStrategy, Component, DestroyRef, Injectable, OnInit, signal} from "@angular/core";
import {NedtrekksmenyKomponent} from "web-ng2/delt/komponenter/nedtrekksmeny/nedtrekksmeny";
import {NedtrekksmenyTriggerForDirektiv} from "web-ng2/delt/komponenter/nedtrekksmeny/nedtrekksmeny-trigger-for";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {InternLenkeNodeAttr, InternLenkeType} from "web-ng2/delt/komponenter/skjema/riktekst-redigering/tiptap/utvidelser/InternLenke";
import {SakDatatjeneste} from "felles-ng2/tjenester/datalager/SakDatatjeneste";
import {SakVisKompaktKomponent} from "web-ng2/moduler/sak/komponenter/sak-vis-kompakt/sak-vis-kompakt";
import {AngularNodeViewComponent} from "web-ng2/delt/komponenter/skjema/riktekst-redigering/ngx-tiptap/src/lib/node-view.component";

const debug = initDebugger('RiktekstRedigeringInternLenkeVisKomponent')

/** Komponent som rendrer intern-lenke.
 * MERK at denne ikke kan benyttes utenfor tiptap editor
 * @Deprecated - internlenker håndteres av tiptap/utvidelser/Lenke.ts */
@Component({
    selector: 'riktekst-redigering-intern-lenke-vis',
    templateUrl: 'intern-lenke-vis.html',
    styleUrl: 'intern-lenke-vis.scss',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NedtrekksmenyKomponent,
        NedtrekksmenyTriggerForDirektiv,
        SakVisKompaktKomponent
    ]
})
export class RiktekstRedigeringInternLenkeVisKomponent extends AngularNodeViewComponent {

    viserDetaljer = signal(false);

    constructor(private avhengigheter: RiktekstRedigeringInternLenkeVisKomponentAvhengigheter) {
        super();
    }

    data(): InternLenkeNodeAttr {
        return this.node().attrs as InternLenkeNodeAttr;
    }

    lenketype(): InternLenkeType {
        //@todo finne mer robust metode - legge til type i InternLenkeNodeAttr?
        return this.node().type.name == 'internLenke_sak' ? 'sak' : 'dokument';
    }

    visDetaljer() {
        this.viserDetaljer.set(true);
    }

}


@Injectable()
export class RiktekstRedigeringInternLenkeVisKomponentAvhengigheter {

    constructor(private sakDatatjeneste: SakDatatjeneste) {
    }
}
